/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1500 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Hamza Naseer",
  title: "Hi all, I'm Hamza",
  subTitle: emoji(
    "Principal AI Architect 🚀 with 7+ years of experience designing and shipping AI-driven products across cloud, robotics, IoT and full-stack systems. I architect scalable GenAI applications on Azure — RAG pipelines, LLM-powered voice agents and multimodal AI — and lead cross-functional teams that take Machine Learning from idea to production in healthcare, eCommerce, SaaS and education."
  ),
  // Resume served from public/resume.pdf — replace that file to update the resume everywhere
  resumeLink: process.env.PUBLIC_URL + "/resume.pdf",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/umegs",
  linkedin: "https://www.linkedin.com/in/umegs-hamza",
  gmail: "umegs.hamza@gmail.com",
  kaggle: "https://www.kaggle.com/umegshamza",
  phone: "+923058731372",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "PRINCIPAL AI ARCHITECT WHO TURNS GENAI, MACHINE LEARNING AND ROBOTICS INTO PRODUCTION-GRADE PRODUCTS",
  skills: [
    emoji(
      "⚡ Architect scalable GenAI applications on Azure — RAG pipelines, LLM agents, Azure OpenAI, AI Search and Cognitive Services"
    ),
    emoji(
      "⚡ Build and deploy end-to-end Machine Learning and Deep Learning systems for Computer Vision, NLP and Speech with MLOps best practices"
    ),
    emoji(
      "⚡ Develop AI voice agents and chatbots with LangChain / LangGraph, GPT-4, Whisper, Twilio and Azure Communication Services"
    ),
    emoji(
      "⚡ Engineer Robotics and IoT solutions — ROS2, SLAM, microcontrollers and real-time computer vision on the edge"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
  https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Azure",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "GenAI / LLMs",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "Machine Learning",
      fontAwesomeClassname: "fas fa-cogs"
    },
    {
      skillName: "Deep Learning",
      fontAwesomeClassname: "fas fa-network-wired"
    },
    {
      skillName: "Computer Vision",
      fontAwesomeClassname: "fas fa-eye"
    },
    {
      skillName: "NLP",
      fontAwesomeClassname: "fas fa-comment-dots"
    },
    {
      skillName: "Robotics / ROS2",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "IoT & Edge",
      fontAwesomeClassname: "fas fa-microchip"
    },
    {
      skillName: "PyTorch",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Databases",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "fab fa-node"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "UMT - University of Management and Technology",
      logo: require("./assets/images/umtLogo.png"),
      subHeader: "Executive MBA (EMBA)",
      duration: "2024 - 2026",
      desc: "Completed an Executive MBA, aligning technical leadership with strategic business decision-making.",
      descBullets: [
        "Focus on strategy, product leadership and business development for technology organizations."
      ]
    },
    {
      schoolName: "GIFT University",
      logo: require("./assets/images/gift_logo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2016 - September 2020",
      desc: "Secured 1st position in the BSCS program, with a focus on Software Engineering, Data Science, and Machine Learning.",
      descBullets: [
        "Developed proficiency in Python, Java, and JavaScript for software development.",
        "Applied statistical methods and data analysis techniques to solve complex problems.",
        "Completed projects on Data Visualization, Machine Learning, and Natural Language Processing."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, // Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "GenAI & LLM Engineering", // Insert stack or technology you have experience in
      progressPercentage: "95%" // Insert relative proficiency in percentage
    },
    {
      Stack: "Machine Learning & Deep Learning",
      progressPercentage: "90%"
    },
    {
      Stack: "Azure Cloud & MLOps",
      progressPercentage: "90%"
    },
    {
      Stack: "Python · FastAPI · Flask · Django",
      progressPercentage: "92%"
    },
    {
      Stack: "Computer Vision & Robotics (ROS2)",
      progressPercentage: "85%"
    },
    {
      Stack: "Full-Stack · React · Node.js",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, // Set it to true to show workExperiences Section
  experience: [
    {
      role: "Principal Consultant - AI",
      company: "Systems Limited",
      companylogo: require("./assets/images/systemsLimitedLogo.png"),
      date: "March 2024 – Present",
      desc: "Leading GenAI architecture and delivery for enterprise clients on Azure and AWS — designing LLM-powered platforms, AI voice agents and RAG pipelines while coordinating frontend, backend, data science and DevOps teams.",
      descBullets: [
        "Architected a production AI call agent for eCommerce using Azure Communication Services, Copilot Studio, Azure OpenAI, Azure AI Search and Direct Line Speech.",
        "Built a second voice-agent stack on Twilio + Groq + Whisper with LiveKit for real-time audio and automated WhatsApp/SMS follow-ups.",
        "Led Reteta, a doctor–patient encounter and medical-coding platform — AWS Bedrock, SageMaker, LangChain multi-agent workflows, Django and React — owning teams end to end.",
        "Built a YouTube AI Insights tool with Azure OpenAI, LangChain, Cosmos DB and Azure Blob Storage.",
        "Delivered GenAI trainings, presales demos and solution architectures for enterprise stakeholders."
      ],
      technologies: [
        "Azure OpenAI",
        "Copilot Studio",
        "LangChain / LangGraph",
        "AWS Bedrock",
        "SageMaker",
        "Twilio · LiveKit",
        "Django · React",
        "Terraform"
      ]
    },
    {
      role: "Senior Data Scientist / AI Engineer",
      company: "PureLogics",
      companylogo: require("./assets/images/pureLogicsLogo.png"),
      date: "August 2023 – March 2024",
      desc: "Built production GenAI chatbots and LLM applications for retail, faith-tech and wellness clients using LangChain, OpenAI and full-stack integrations.",
      descBullets: [
        "Developed ShopGPT, a retail chatbot enabling natural-language queries over store data with GPT-powered RAG and tabular insights (LangChain, OpenAI, Flask, ReactJS, Shopify).",
        "Led IBIS AI, a personality-aware mindset-analysis chatbot built with Next.js, LangChain and GPT-4.",
        "Architected Pastors.ai, a sermon-video Q&A chatbot using Whisper transcription, Pinecone vector search and LangChain retrieval.",
        "Conducted R&D on LLM retrieval quality and interactive chat UX across all three products."
      ],
      technologies: [
        "LangChain",
        "OpenAI GPT-4",
        "Whisper",
        "Pinecone",
        "Flask",
        "Next.js",
        "AWS"
      ]
    },
    {
      role: "Data Scientist",
      company: "Nextbridge Ltd.",
      companylogo: require("./assets/images/nextbridgeLogo.png"),
      date: "September 2022 – August 2023",
      desc: "Delivered computer-vision and robotics projects — real-time damage detection, medical imaging and autonomous robots — using Python, PyTorch and ROS2.",
      descBullets: [
        "Developed a real-time multi-class damage detection system using YOLOv8.",
        "Led landmark-detection development for precise Cobb-angle estimation in scoliosis assessment.",
        "Built an autonomous golf-ball retrieving robot using ROS2, SLAM (Rtabmap) and object detection.",
        "Implemented face-recognition employee monitoring to enhance workplace security."
      ],
      technologies: [
        "YOLOv8",
        "PyTorch",
        "OpenCV",
        "ROS2",
        "Rtabmap",
        "TensorFlow"
      ]
    },
    {
      role: "Associate Data Scientist",
      company: "Babyplanet.pk",
      companylogo: require("./assets/images/babyplanetLogo.png"),
      date: "January 2021 – August 2022",
      desc: "Worked as Python Developer and Associate Data Scientist — built Django web apps for order processing, a custom ERP integrated with courier services, and data-mining systems.",
      descBullets: [
        "Designed and developed order-processing web apps using Django, ReactJS and Magento APIs.",
        "Completed a custom ERP integrated with 5+ courier services for order booking.",
        "Implemented association rule mining for personalized product recommendations."
      ],
      technologies: [
        "Django",
        "ReactJS",
        "Magento APIs",
        "Postgres",
        "Data Mining"
      ]
    },
    {
      role: "Web Developer",
      company: "Hixol",
      companylogo: require("./assets/images/hixolLogo.png"),
      date: "May 2020 – January 2021",
      desc: "Developed online shopping stores and a fundraising platform for nonprofits using PHP, Laravel and CodeIgniter with smooth, Ajax-driven user experiences.",
      descBullets: [
        "Created the Deliver Cart and Clickit247 online stores using CodeIgniter REST APIs and Ajax.",
        "Developed Gratifika, a free fundraising service for nonprofits, with Laravel and ReactJS.",
        "Built order workflows, live cart updates and custom admin dashboards."
      ],
      technologies: ["Laravel", "CodeIgniter", "PHP", "ReactJS", "Ajax"]
    },
    {
      role: "Software Engineering Trainee",
      company: "Stewart Pakistan Private Limited",
      companylogo: require("./assets/images/stewartLogo.png"),
      date: "September 2018 – November 2018",
      desc: "Internship building an Employee Monitoring System — desktop and web applications with face recognition and location tracking.",
      descBullets: [
        "Developed a desktop application for displaying important notes for employees.",
        "Worked on a web application for employee data retrieval and monitoring.",
        "Integrated face recognition with CCTV cameras for real-time employee tracking."
      ],
      technologies: ["OpenCV", "Python", "C#", "ASP.NET", "MySQL"]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Huawei AI Certification",
      subtitle:
        "Certified in Huawei AI course (HCIA), enhancing my expertise in Artificial Intelligence.",
      image: require("./assets/images/huaweiAILogo.png"),
      imageAlt: "Huawei AI Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1zlqCOV-ujlKV4Y4e62U74sTnNUyWOaGd/view?usp=sharing"
        }
      ]
    },
    {
      title: "Azure AI Fundamentals Certification",
      subtitle:
        "Microsoft-certified in Azure AI Fundamentals, strengthening my knowledge of AI technologies on the Azure platform.",
      image: require("./assets/images/azureAILogo.png"),
      imageAlt: "Azure AI Fundamentals Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1g7zrdJbw-UEYRrIap3BKbUGuqTNfyFu7/view?usp=sharing"
        }
      ]
    },
    {
      title: "GIFT UNIVERSITY 1st Position",
      subtitle:
        "Secured 1st Position in the BSCS program at GIFT University, reflecting academic excellence.",
      image: require("./assets/images/giftLogo_certification.png"),
      imageAlt: "GIFT University Logo",
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/1BxaEnmTd-cf--VJGpSRW4hCOoU5gSgep/view?usp=sharing"
        }
      ]
    },
    {
      title: "NAVTTC AI Course Certification",
      subtitle:
        "Completed NAVTTC AI Course, expanding my knowledge in the field of Artificial Intelligence.",
      image: require("./assets/images/navttcLogo.png"),
      imageAlt: "NAVTTC Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1cT_I5jHy13k-i-dR9tWQhugwYo6EXlI7/view?usp=sharing"
        }
      ]
    },
    {
      title: "Space App Challenge",
      subtitle:
        "Participated in the Space App Challenge, showcasing innovation and problem-solving abilities.",
      image: require("./assets/images/spaceAppLogo.png"),
      imageAlt: "Space App Challenge Logo",
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/1T-i3m12ym2CRUq65NzNN2q9lhBHuxHy-/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3058731372",
  email_address: "umegs.hamza@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
